import { render, staticRenderFns } from "./TurnPage.vue?vue&type=template&id=ae03d12c&scoped=true"
import script from "./TurnPage.vue?vue&type=script&lang=js"
export * from "./TurnPage.vue?vue&type=script&lang=js"
import style0 from "./TurnPage.vue?vue&type=style&index=0&id=ae03d12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae03d12c",
  null
  
)

export default component.exports